import { SET_VENDOR_CUSTOMER_STATEMENT } from "../Types/VendorCustomerStatementTypes";
import {
  CLOSE_LOADER,
  SET_ERROR,
  SET_LOADER,
} from "../Types/AuthTypes";
import backendVerifiedUser from "../../api/backendVerifiedUser";

export const getVendorCustomerStatements = (data) => {
    return async (dispatch) => {
      dispatch({ type: SET_LOADER });
      try {
        const response = await backendVerifiedUser.post(
          "/getVenderCustomerStatementReport",
          data
        );
        dispatch({ type: CLOSE_LOADER });
  
        dispatch({ type: SET_VENDOR_CUSTOMER_STATEMENT, payLoad: response.data });
      } catch (err) {
        dispatch({ type: CLOSE_LOADER });
        console.log(err);
        dispatch({
          type: SET_ERROR,
          payLoad: err.response?.data?.error?.msg,
        });
      }
    };
  };